import React, { createContext, useContext } from "react";
import { normalizeRegion } from "@/utils/stateRestrictionUtils";

export type UserInfo = {
    region?: string | null;
    country?: string | null;
    city?: string | null;
    latLong?: string | null;
};

const UserInfoContext = createContext<UserInfo>({
        region: null,
        country: null,
        city: null,
        latLong: null,
    });

export const useUserInfo = () => useContext(UserInfoContext);

type UserInfoProviderProps = {
    value?: UserInfo;
    children: React.ReactNode;
};

export const UserInfoProvider = ({
    value = {},
    children,
}: UserInfoProviderProps) => {
    const normalizedValue = {
        region: normalizeRegion(value.region || ""),
        country: value.country?.toUpperCase(),
        city: value.city,
        latLong: value.latLong,
    }
    return (
    <UserInfoContext.Provider value={normalizedValue}>
        {children}
    </UserInfoContext.Provider>
)};
